/* This file is autogenerated, see readme.md for instructions */
import ExpressionSvgIcon from '@bloomreach/banana-theme/icons/expression.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ExpressionIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ExpressionSvgIcon />
    </Icon>
  );
});

ExpressionIcon.displayName = 'ExpressionIcon';

export default ExpressionIcon;
